import type { PlatformCostProviderCatalogEntry, PlatformCostProviderId } from './types';

/**
 * The single declaration of every provider the product knows about. Typing this
 * as a total Record means adding an id to `PlatformCostProviderId` fails to
 * compile until the entry exists here.
 */
const providerCatalog: Record<PlatformCostProviderId, PlatformCostProviderCatalogEntry> = {
    twilio: {
        id: 'twilio',
        name: 'Twilio',
        description:
            'Usage Records across the master account and subaccounts — voice, SMS, numbers, and media.',
        resourceNoun: { singular: 'subaccount', plural: 'subaccounts' },
        childResourceNoun: null,
        ingestionMode: 'api_sync',
    },
    openai: {
        id: 'openai',
        name: 'OpenAI',
        description: 'Model inference and related API usage.',
        resourceNoun: { singular: 'project', plural: 'projects' },
        childResourceNoun: { singular: 'API key', plural: 'API keys' },
        ingestionMode: 'api_sync',
    },
    gcp: {
        id: 'gcp',
        name: 'Google Cloud',
        description: 'Compute, storage, networking, and data services powering the platform.',
        resourceNoun: { singular: 'project', plural: 'projects' },
        childResourceNoun: null,
        ingestionMode: 'api_sync',
    },
    fireworks: {
        id: 'fireworks',
        name: 'Fireworks',
        description: 'Serverless and dedicated model inference usage.',
        resourceNoun: { singular: 'account', plural: 'accounts' },
        childResourceNoun: null,
        ingestionMode: 'api_sync',
    },
    manychat: {
        id: 'manychat',
        name: 'ManyChat',
        description: 'Messaging automation subscription billed monthly from invoices.',
        resourceNoun: { singular: 'account', plural: 'accounts' },
        childResourceNoun: null,
        ingestionMode: 'manual_entry',
    },
    anthropic: {
        id: 'anthropic',
        name: 'Anthropic',
        description: 'Claude model inference and related API usage.',
        resourceNoun: { singular: 'workspace', plural: 'workspaces' },
        childResourceNoun: null,
        ingestionMode: 'unavailable',
    },
    deepgram: {
        id: 'deepgram',
        name: 'Deepgram',
        description: 'Speech-to-text and text-to-speech processing.',
        resourceNoun: { singular: 'project', plural: 'projects' },
        childResourceNoun: null,
        ingestionMode: 'unavailable',
    },
    stripe: {
        id: 'stripe',
        name: 'Stripe',
        description: 'Payment processing fees and billing infrastructure.',
        resourceNoun: { singular: 'account', plural: 'accounts' },
        childResourceNoun: null,
        ingestionMode: 'unavailable',
    },
};

export default providerCatalog;
